module.exports = __webpack_public_path__ + "static/img/icon-summer@2x.fa8354b6.png";